<form [formGroup]="formGroup">
  <mat-form-field appearance="fill" style="width: 100%">
    <mat-chip-grid #chipList [required]="required" formControlName="chips">
      <mat-chip-row *ngFor="let chip of selectedValues" [removable]="removable" (removed)="remove(chip)">
        {{chip.value}}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip-row>

      <input
        #chipsInput
        placeholder="Select value..."
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="addChip($event)"
        [matAutocomplete]="chipsAutocomplete"
        formControlName="chipsInput"
      />
      <i *ngIf="isLoading == true;" class="fas fa-spinner fa-spin"></i>
    </mat-chip-grid>
    <mat-autocomplete #chipsAutocomplete="matAutocomplete" (optionSelected)="selectChip($event)">
      <mat-option *ngFor="let value of filteredValues$ | async" [value]="value">
        {{value.value}}
      </mat-option>
    </mat-autocomplete>
    <mat-error>At least 1 item need to be added</mat-error>
  </mat-form-field>
</form>